import { render, staticRenderFns } from "./GC.vue?vue&type=template&id=95348d8c&scoped=true&"
import script from "./GC.vue?vue&type=script&lang=js&"
export * from "./GC.vue?vue&type=script&lang=js&"
import style0 from "./GC.vue?vue&type=style&index=0&id=95348d8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95348d8c",
  null
  
)

export default component.exports